import _get from 'lodash/get';
import queryString from 'query-string';
import { COOKIES } from '../constants';
import { getParsedCookie } from '../utils/cookieHelpers';

/**
 * This function gets custom attributes for experiments
 * - it is temporary functionality and will be replaced by an experiments service the Growth team is creating
 * @param {string} experimentToken
 */
export const getCustomAttributes = (experimentToken: string) => {
  if (!experimentToken) {
    return {};
  }

  const signUpVals = getParsedCookie(COOKIES.SELECTED_PACKAGES);
  let hasDoubleFreePlan;
  if (!signUpVals || !signUpVals.packages) {
    hasDoubleFreePlan = true;
  } else {
    const eiPlanId = signUpVals.packages.e;
    const mcPlanId = signUpVals.packages.mc;
    hasDoubleFreePlan =
      eiPlanId === 'sg.ei.free-100.v1' && mcPlanId === 'sg.mc.free.v1';
  }

  const parsedQueryString = queryString.parse(
    _get(window, 'location.search', '')
  );
  const isResellerCustomer = Boolean(
    parsedQueryString.gcp || parsedQueryString.aws
  );

  const mobileRe = new RegExp(
    '/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/'
  );
  const isDesktopUser = !mobileRe.test(navigator.userAgent);

  return {
    experimentToken,
    hasDoubleFreePlan,
    isResellerCustomer,
    isDesktopUser
  };
};
